module.exports = __webpack_public_path__ + "media/assets/images/blog/change_managemen-small-81426d4112c7de42388b40bdf3ecb4cb.png";